import { Pipe, PipeTransform } from '@angular/core';
import { TimeZoneAvailableResponseModel } from '../shared/models/response/time-zone-available-response-model';
import { WebStorageService } from '../shared/services/web-storage.service';

@Pipe({
    name: 'timezone',
    standalone: false
})
export class TimezonePipe implements PipeTransform {
  timeZoneList: TimeZoneAvailableResponseModel[];
  constructor( 
    private webStorageService: WebStorageService){
      this.timeZoneList = this.webStorageService.getTimeZoneList();
  }

  transform(timezone) {
    if (!timezone) return '';
    
    try {
      if (!this.timeZoneList || !this.timeZoneList.length) {
        return timezone;
      }
      
      timezone = timezone.replace(" ", "");
      const found = this.timeZoneList.find(x => x.appTimeZoneOffSet == timezone);
      if (found && found.appDisplayTimeZoneCode) {
        return found.appDisplayTimeZoneCode;
      }
      return timezone;
    } catch (e) {
      return timezone;
    }
  }
}